// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3NnLQ","footer":"ReportModalFilter_footer__w1agi"};